/** Tipos de seção da página customizada (TipoSecaoPaginaCustomizada no backend). */
export enum CustomPageSectionType {
    TextoLivre = 1,
    ListaItens = 2,
    GaleriaImagens = 3,
    Faq = 4,
    ConteudoMisto = 5,
    VideoEmbed = 6,
    ListaLinks = 7,
    Documentos = 8
}

export interface IPortalCustomPageSectionItemResponse {
    id: number,
    sectionId: number,
    title: string | undefined,
    subtitle: string | undefined,
    description: string | undefined,
    url: string | undefined,
    image: string | undefined,
    imageUrl: string | undefined,
    /** Lista de links: nome do ícone Material (mesmo padrão do Acesso Rápido, ex.: "link", "picture_as_pdf"). */
    icon: string | undefined,
    /** Lista de links: abre o link em nova aba. */
    openInNewTab: boolean,
    /** Documentos: caminho do arquivo no bucket do portal. */
    file: string | undefined,
    /** Documentos: URL pública para download. */
    fileUrl: string | undefined,
    /** Documentos: nome do arquivo enviado pelo usuário (com extensão). */
    fileOriginalName: string | undefined,
    /** Documentos: tamanho em bytes. */
    fileSize: number | undefined,
    order: number
}

export interface IPortalCustomPageSectionResponse {
    id: number,
    type: CustomPageSectionType,
    title: string | undefined,
    subtitle: string | undefined,
    content: string | undefined,
    url: string | undefined,
    image: string | undefined,
    imageUrl: string | undefined,
    configuration: string | undefined,
    order: number,
    items: IPortalCustomPageSectionItemResponse[] | undefined
}

export interface IPortalCustomPageResponse {
    id: number,
    title: string | undefined,
    slug: string | undefined,
    summary: string | undefined,
    metaDescription: string | undefined,
    metaKeywords: string | undefined,
    coverImage: string | undefined,
    coverImageUrl: string | undefined,
    publishedAt: string | undefined,
    updatedAt: string | undefined,
    sections: IPortalCustomPageSectionResponse[] | undefined
}
